// Single item conversion

export function uint8ArrayToBase64(bytes: Uint8Array): string {
    let binary = "";
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
        binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
}


// Safely parse a timestamp string into a Date or null
export function parseTimestamp(value?: string | null): Date | null {
    if (!value || value.trim() === "") return null;

    const d = new Date(value);
    return isNaN(d.getTime()) ? null : d;
}

// Determine whether a new print is required
export function needsNewPrint(
    criteriaLastUpdated: string | null | undefined,
    titlePageLastUpdated: string | null | undefined,
    latestPrintTimestamp: string | null | undefined
): boolean {
    const criteriaTs = parseTimestamp(criteriaLastUpdated);
    const titlePageTs = parseTimestamp(titlePageLastUpdated);
    const printTs = parseTimestamp(latestPrintTimestamp);

    // If we've never printed before → must print
    if (!printTs) return true;

    // If either updated timestamp exists and is newer → must print
    if (criteriaTs && criteriaTs > printTs) return true;
    if (titlePageTs && titlePageTs > printTs) return true;

    return false;
}

export function formatTime(t: number, pad: number = 2) {
    if (t < 60) return `${t.toFixed(pad)}s`;

    const h = Math.floor(t / 3600);
    const m = Math.floor((t % 3600) / 60);
    const s = Math.floor(t % 60);

    if (h > 0) return `${h}:${m.toString().padStart(pad, '0')}:${s.toString().padStart(pad, '0')}`;
    return `${m}:${s.toString().padStart(pad, '0')}`;
}

export function arrayBufferToFile(
    buffer: ArrayBuffer,
    filename: string,
    mimeType: string
): File {
    const uint8 = new Uint8Array(buffer);
    const blob = new Blob([uint8], { type: mimeType });
    return new File([blob], filename, { type: mimeType });
}


export function formatDateForFilename(epoch: number = Date.now()): string {
    const d = new Date(epoch);

    const pad = (n: number) => n.toString().padStart(2, "0");

    const year = d.getFullYear();
    const month = pad(d.getMonth() + 1);
    const day = pad(d.getDate());

    const hours = pad(d.getHours());
    const minutes = pad(d.getMinutes());
    const seconds = pad(d.getSeconds());

    return `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
}
